import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
    fontWeight: theme.typography.fontWeightLight,
    textTransform: 'capitalize',
  },
}))
